/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_OfflineInputs */

const fr_vehicle_details_offline = /** @type {(inputs: Vehicle_Details_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors-ligne`)
};

const en_vehicle_details_offline = /** @type {(inputs: Vehicle_Details_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Vehicle_Details_OfflineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_offline = /** @type {((inputs?: Vehicle_Details_OfflineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_OfflineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_offline(inputs)
	return en_vehicle_details_offline(inputs)
});